import { render, staticRenderFns } from "./OngoingOperations.vue?vue&type=template&id=3f4bf12c&scoped=true&"
import script from "./OngoingOperations.vue?vue&type=script&lang=js&"
export * from "./OngoingOperations.vue?vue&type=script&lang=js&"
import style0 from "./OngoingOperations.vue?vue&type=style&index=0&id=3f4bf12c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4bf12c",
  null
  
)

export default component.exports